import { render } from "./robot.vue?vue&type=template&id=7c8a53c0&scoped=true"
import script from "./robot.vue?vue&type=script&lang=js"
export * from "./robot.vue?vue&type=script&lang=js"

import "./robot.vue?vue&type=style&index=0&id=7c8a53c0&lang=scss&scoped=true"

import exportComponent from "D:\\codes\\chat28\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8a53c0"]])

export default __exports__